/**
 * Calculates the appropriate image width (imwidth) based on the container width and device pixel ratio.
 * @param imageContainerWidth
 */
export function calculateImwidthForImage(imageContainerWidth: number): number {
	const devicePixelRatio = window.devicePixelRatio ? Math.max(window.devicePixelRatio, 1) : 1
	let imwidth = 0

	// TODO:  For debuggin purposes only.  Remove before golive
	if (!window.devicePixelRatio || window.devicePixelRatio < 1) {
		window.console.log(`Device pixel ratio is less than 1: (${window.devicePixelRatio})`)
	}

	// Take the upper limit of the breakpoint for maximum image quality within each breakpoint range
	if (imageContainerWidth < 481) {
		// SM
		imwidth = 481
	} else if (imageContainerWidth < 900) {
		// MD
		imwidth = 900
	} else if (imageContainerWidth < 1280) {
		// LG
		imwidth = 1280
	} else {
		// Max and above
		imwidth = 1922
	}

	return imwidth * Math.floor(devicePixelRatio)
}
